import { AppContext, DialogSettings } from 'AppContext';
import { Bootstrapper } from 'Bootstrapper';
import { Poller } from './Poller';


export class DialogUtil {
    private context: AppContext;
    private poller: Poller<boolean>;
    private result: boolean = null;
    constructor(){
        this.context = Bootstrapper.getInstance<AppContext>(AppContext);
        this.poller = new Poller<boolean>();
    }

    public confirmDialog(msg: string, onResult: (result: boolean) => any, title: string = null){
        var settings = new DialogSettings(msg, onResult, title);
        this.context.setDialogVisibility(settings);
    }

    public async confirmDialogAsync(msg: string, title: string = null){
        const onResultWrapper = (result: boolean) => {
            this.result = result;
        }

        const fn = async() => {
            const passed = this.result !== null;
            if(passed)
                this.poller.stop = true;
            return this.result;
        }
        var settings = new DialogSettings(msg, onResultWrapper, title);
        this.context.setDialogVisibility(settings);
        return await this.poller.runAsync<boolean>(fn, 1000);
    }
}